import React from "react";

import Header from "../OrderManagement/Header"; // Adjust the path as needed
import {
  Box,
  Typography,
  Button,
  Link,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import InboxIcon from "@mui/icons-material/Inbox";

const List = () => { 
  return (
    <div style={{ background: "white" }}>
      <Header />
      <Box
        p={3}
        sx={{
          margin: "20px",
          boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.1)",
          borderRadius: "10px",
          background: "white",
        }}
      >
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          padding="16px"
        >
          <Typography
            variant="h6"
            style={{ display: "flex", alignItems: "center" }}
          >
            <Link
              href="/order1"
              style={{
                display: "flex",
                alignItems: "center",
                textDecoration: "none",
                color: "inherit",
              }}
            >
              <InboxIcon style={{ marginRight: "8px" }} />
              Order
            </Link>
          </Typography>
          <Button
            variant="contained"
            color="primary"
            startIcon={<AddIcon />}
            component={RouterLink} // React Router Link
            to="/new-order" // New Item path
          >
            New Order
          </Button>
        </Box>
      </Box>
    </div>
  );
};

export default List;
